import React, { useState, Fragment } from "react";
import SideCol from "./SideCol";
import { connect } from "react-redux";
import "./sidebar.css";

function SideBar({
    accountData,
}) {
    const [toggled, setToggled] = useState(false);
    const toggleNav = () => setToggled(!toggled);

    const has_accepted_tos = !!accountData.has_accepted_tos;

    if (!has_accepted_tos) {
        return null;
    }

    return (
        <Fragment>
            <i
                style={{
                    position: "fixed",
                    top: "10%",
                    right: "2rem",
                    fontSize: "2rem",
                    cursor: "pointer"
                }}
                className={"fa fa-bars"}
                onClick={toggleNav}
            />

            {/* <div className={"col-md-2"}>*/}
            <SideCol toggled={toggled} onClose={toggleNav} />
            {/* </div>*/}
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    accountData: state.account.accountData,
});

export default connect(mapStateToProps, {})(SideBar);
